import * as React from 'react';
import * as _ from 'underscore';

import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';

export interface ResetPasswordProviderProps extends ReactDirectiveProps {
  readonly token: string;
  readonly username: string;
}

export const ResetPasswordProvider = (props: ResetPasswordProviderProps): JSX.Element => {
  const token = _.isUndefined(props.token) ? '' : props.token;
  return(
    <div>
      <AngularDirective
        template={`<tb:password-reset username=${props.username} token=${token}/>`}
        angularContext={props.angularContext}
      />
    </div>
  );
};
